import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth, apiErr } from "@/context/AuthContext";
import { AuthShell, inputCls, btnCls } from "@/components/AuthShell";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", phone: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      await register(form);
      toast.success("Account created!");
      navigate("/portal");
    } catch (err) {
      setError(apiErr(err));
    } finally { setLoading(false); }
  };

  return (
    <AuthShell title="Create your account" sub="Track bookings and manage your cleanings."
      footer={<>Already have an account? <Link to="/login" className="text-[#B87333] font-medium hover:underline" data-testid="to-login">Sign in</Link></>}>
      <form onSubmit={submit} className="space-y-4" data-testid="register-form">
        <div>
          <label className="text-sm font-medium text-[#2C2621]">Full name</label>
          <input required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className={inputCls} data-testid="register-name" />
        </div>
        <div>
          <label className="text-sm font-medium text-[#2C2621]">Email</label>
          <input type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className={inputCls} data-testid="register-email" />
        </div>
        <div>
          <label className="text-sm font-medium text-[#2C2621]">Phone</label>
          <input value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} className={inputCls} data-testid="register-phone" />
        </div>
        <div>
          <label className="text-sm font-medium text-[#2C2621]">Password</label>
          <input type="password" required minLength={6} value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} className={inputCls} data-testid="register-password" />
        </div>
        {error && <p className="text-sm text-red-600" data-testid="register-error">{error}</p>}
        <button type="submit" disabled={loading} className={btnCls} data-testid="register-submit">{loading ? "Creating…" : "Create account"}</button>
      </form>
    </AuthShell>
  );
}
